import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";

@Injectable({
  providedIn: 'root'
})
export class SendmsgService extends BaseService {
  _messageSource = new Subject<any>();
  message$ = this._messageSource.asObservable();
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
    this.sendMessage(this.message$);
  }

  sendMessage(message: any) {
    this._messageSource.next(message);
  }
}
